import { analyticsFactory as n } from "@scalar/analytics-client";
import { useClientConfig as o } from "./hooks/useClientConfig.js";
import { analytics as i } from "./layouts/Web/create-api-client-web.js";
import { analytics as a } from "./layouts/App/create-api-client-app.js";
import { useLayout as r } from "./hooks/useLayout.js";
function y() {
  return n(
    "https://api.scalar.com",
    () => null
    // There is no auth to return.
  );
}
function f() {
  const { layout: t } = r();
  return o().value.telemetry ? {
    desktop: a,
    web: i,
    modal: void 0
    // There are currently no analytics for the modal layout.
  }[t] : void 0;
}
export {
  y as createAnalyticsClient,
  f as useAnalytics
};
